import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "src/app/models/User";
import { HttpService } from '../../services/http/http.service';
import { ResponseLogin } from "src/app/models/ResponseLogin";
@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpService) { }


  /***
   * Register Account
   */
  public Register(user :User) : Observable<any>{
    return this.http.post<any>('/api/Authentication/Register', user);
  }

  /***
   * Login Account
   */
  public Login(username: string,password:string): Observable<ResponseLogin>{
    var payload = {
        Username : username,
        Password : password
    }
    return this.http.post<ResponseLogin>('/api/Authentication/Login',payload);
  }

}